import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import { CModal } from '@coreui/react';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const ImportStudent = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const inputRef = useRef(null);

    const initialFormState = {
        sectionMasterId: sectionMasterId,
        instituteMasterId: instituteMasterId,
        year: '',
        gradeId: '',
        divisionId: '',
        importFile: ''
    }

    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState([])
    const [refresh, setRefresh] = useState(true)
    const [importStudentData, setImportStudentData] = useState(initialFormState)
    const [importStudentList, setImportStudentList] = useState([])
    const [editId, setEditId] = useState(null)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState([])
    const [jsonPars, setJasonParse] = useState([])
    const [text, setText] = useState('')
    const [showPdfLinkdataType, setShowPdfLikDateType] = useState()
    const [selectedGrade, setSelectedGrade] = useState()
    const [selectedDivision, setSelectedDivision] = useState()

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [totalStudentCountSort, setTotalStudentCountSort] = useState(null);
    const [importStudentCountSort, setImportStudentCountSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["totalStudentCount", "importedStudentCount", "instituteGradeMasterDetails.gradeName", "instituteDivisionMasterDetails.divisionName"];

    const [loading, setLoading] = useState(false);
    //error
    const initialErrorState = {
        year: '',
        gradeId: '',
        divisionId: '',
        importFile: ''
    }
    const [error, setError] = useState(initialErrorState)
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList()
        getYearList()
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getImportStudentList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (importStudentData.year !== '') {
                setImportStudentList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(importStudentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(importStudentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > importStudentList.length) {
            endIndex = importStudentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(importStudentList.slice(startIndex, endIndex));
    }, [importStudentList, currPage, itemsPerPage]);

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    useEffect(() => {
        getImportStudentList();
    }, [importStudentData]);

    const getImportStudentList = async () => {
        if (importStudentData.year !== '') {
            try {
                const response = await authorizedAxiosSection.get(getApiUrl())
                setImportStudentList(response.data.result);
            } catch (error) {
                setImportStudentList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }


    const getApiUrl = () => {
        let apiUrl = `/student-import?&instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;
        if (importStudentData.year !== '') {
            apiUrl += `year=${importStudentData.year}&`;
        }
        if (importStudentData.gradeId !== '') {
            apiUrl += `gradeId=${importStudentData.gradeId}&`;
        }
        if (importStudentData.divisionId !== '') {
            apiUrl += `divisionId=${importStudentData.divisionId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const handleGradeChange = (e) => {
        setImportStudentData((prevData) => {
            return {
                ...prevData,
                divisionId: '',
                [e.target.name]: e.target.value
            }
        })
        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setImportStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(importStudentData).every((value) => value.trim() !== '')
    }

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(importStudentData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [importStudentData])

    const addStudent = async () => {
        const apiUrl = `/student-import`;
        if (validateForm()) {
            try {
                setLoading(true);
                const response = await authorizedAxiosSection.post(apiUrl, importStudentData);
                await getImportStudentList();
                setImportStudentData((prevData) => {
                    return {
                        ...prevData,
                        importFile: '',
                    }
                })

                setTotalStudentCountSort(null);
                setImportStudentCountSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(importStudentData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError(initialErrorState)
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-pdf-book?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, importStudentList.length);
                await getImportStudentList();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateLesson = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-lesson-master?id=${editId}`;
            const response = await authorizedAxiosInstitute.put(apiUrl, importStudentData);
            await getImportStudentList();
            setEditId(null);
            setImportStudentData(initialFormState);

            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];
        let fileExtention = file.name.split(".").pop();
        const body = new FormData();
        body.append("file", file);

        if (fileExtention === "xlsx") {
            if (file.size < 150 * 1024) {
                setLoading(true);
                const apiUrl = "uploadfile";
                authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                    .then((res) => {
                        setImportStudentData((prevData) => {
                            if (e.target.name === 'importFile' && file) {
                                return {
                                    ...prevData,
                                    importFile: res.data.result,
                                }
                            }
                        })
                    })
                    .catch((err) => {
                        const errorMsg = err?.response?.data?.error || "Something went wrong!";
                        Swal.fire({
                            text: errorMsg
                        })
                    })
                    .finally(() => {
                        setLoading(false); // End loading
                    });
            } else {
                e.target.value = ''
                Swal.fire(
                    { text: "max size 200 kb file supported" }
                );
            }
        } else {
            e.target.value = ''
            Swal.fire(
                { text: "only xlsx file supported" }
            );
        }
    }

    useEffect(() => {
        if (showPdfLink !== null) {
            if (showPdfLink.indexOf('[') >= 0) {
                setShowPdfLikDateType("array")
                setJasonParse(JSON.parse(showPdfLink))
            }
            else {
                setShowPdfLikDateType("string")
                setText(showPdfLink)
            }
        } else {
            setShowPdfLikDateType("string")
            setText(showPdfLink)
        }
    }, [showPdfLink])

    useEffect(() => {
        if (totalStudentCountSort == true || totalStudentCountSort == false) {
            setImportStudentCountSort(null);
        }
    }, [totalStudentCountSort])

    useEffect(() => {
        if (importStudentCountSort == true || importStudentCountSort == false) {
            setTotalStudentCountSort(null);
        }
    }, [importStudentCountSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />

                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Import Student</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-user-plus"></i> Import Student</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='year' onChange={handleInputChange} value={importStudentData.year}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            yearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.year && <p style={{ color: 'red' }}>{error.year}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='gradeId' onChange={handleGradeChange} value={importStudentData.gradeId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.gradeId && <p style={{ color: 'red' }}>{error.gradeId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='divisionId' onChange={handleInputChange} value={importStudentData.divisionId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.divisionId && <p style={{ color: 'red' }}>{error.divisionId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Import Student :</label>
                                                    <label style={{ color: "red" }} > max 200 kb xlsx file supported</label>

                                                    <input type="file" className="form-control" name="importFile" onChange={handleUploadLogo} ref={inputRef} />
                                                    {error.importFile && <p style={{ color: 'red' }}>{error.importFile}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <a download href='https://api.examninja.co.in/files/student-import-sample-file.xlsx'>Sample xlsx file</a>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addStudent}>Save</button>}
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setImportStudentList([]); setEditId(''); setImportStudentData(initialFormState); inputRef.current.value = '' }}>Reset</button>

                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateLesson} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No.</th>
                                                                        <th scope="col">Live Path </th>
                                                                        <th scope="col">
                                                                            Total Student Count
                                                                            <SortIcon sortState={totalStudentCountSort} setSortState={setTotalStudentCountSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"totalStudentCount"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Imported Student Count
                                                                            <SortIcon sortState={importStudentCountSort} setSortState={setImportStudentCountSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"importedStudentCount"} />
                                                                        </th>
                                                                        <th scope="col">Class</th>
                                                                        <th scope="col">Division</th>
                                                                        <th scope="col">Error</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {lesson.importStatus != "NOT STARTED" ? <tr className={lesson.totalStudentCount != lesson.importedStudentCount ? "redTable" : lesson.importStatus == "IMPORTED" ? 'greenTable' : lesson.importStatus == "FAILED" ? "redTable" : lesson.importStatus == "NOT STARTED" ? "yellowTable" : "yellowTable"}>
                                                                                            <th scope="row">{startIndex + index + 1}</th>
                                                                                            <td><a href={lesson.liveFilePath} download> Live Path</a></td>
                                                                                            <td>{lesson.totalStudentCount}</td>
                                                                                            <td>{lesson.importedStudentCount}</td>
                                                                                            <td>{lesson?.instituteGradeMasterDetails?.gradeName}</td>
                                                                                            <td>{lesson?.instituteDivisionMasterDetails?.divisionName}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon" type="button" onClick={() => {

                                                                                                    setShowPdfLink(lesson.note)
                                                                                                    setVisible(true)
                                                                                                    setSelectedGrade(lesson?.instituteGradeMasterDetails?.gradeName)
                                                                                                    setSelectedDivision(lesson?.instituteDivisionMasterDetails?.divisionName)
                                                                                                }}><i class="fa fa-eye" ></i> Error</button>
                                                                                            </td>
                                                                                        </tr> :
                                                                                            <> <tr className={lesson.importStatus == "IMPORTED" ? 'greenTable' : lesson.importStatus == "FAILED" ? "redTable" : lesson.importStatus == "NOT STARTED" ? "yellowTable" : "yellowTable"}>
                                                                                                <th scope="row">{index + 1}</th>
                                                                                                <td><a href={lesson.liveFilePath} download> Live Path</a></td>
                                                                                                <td>{lesson.totalStudentCount}</td>
                                                                                                <td>{lesson.importedStudentCount}</td>
                                                                                                <td>{lesson?.instituteGradeMasterDetails?.gradeName}</td>
                                                                                                <td>{lesson?.instituteDivisionMasterDetails?.divisionName}</td>
                                                                                                <td>
                                                                                                    <button disabled className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                        setShowPdfLink(lesson.note)
                                                                                                        setVisible(true)
                                                                                                        setSelectedGrade(lesson?.instituteGradeMasterDetails?.gradeName)
                                                                                                        setSelectedDivision(lesson?.instituteDivisionMasterDetails?.divisionName)
                                                                                                    }}><i class="fa fa-eye" ></i> Note</button>
                                                                                                </td>
                                                                                            </tr>
                                                                                                <tr>
                                                                                                    <td colspan={"100%"} style={{ textAlign: 'center' }}>
                                                                                                        File is Loading Please Or Refresh The Web Page <i class="fa fa-refresh" onClick={() => setRefresh(!refresh)}></i>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={importStudentList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
            >
                <div className="book book-modal">
                    <div className='table-header-like'> Class - {selectedGrade}   and   Division - {selectedDivision}</div>
                    <div style={{ overflowY: "scroll", }} className='page' >
                        <div>
                            {
                                showPdfLinkdataType == "array" ?
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col" className='sl_no'>Sr. No.</th>
                                                <th scope="col">Name </th>
                                                <th scope="col">Purpose </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                jsonPars.map((lesson, index) => {
                                                    return (
                                                        <tr>
                                                            <th scope="row" className='sl_no'>{index + 1}</th>
                                                            <td>{lesson.record[2]}</td>
                                                            <td>{lesson.purpose}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div>{text}</div>
                            }
                        </div>

                    </div>
                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                        Close
                    </button>
                </div>
            </CModal>
        </>
    )
};

export default ImportStudent;